module.exports = __webpack_public_path__ + "static/media/fontawesome-2.b314e1bf.png";